import { render, staticRenderFns } from "./usergroup.vue?vue&type=template&id=533183c2&scoped=true"
import script from "./usergroup.vue?vue&type=script&lang=js"
export * from "./usergroup.vue?vue&type=script&lang=js"
import style0 from "./usergroup.vue?vue&type=style&index=0&id=533183c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533183c2",
  null
  
)

export default component.exports